import styled from 'styled-components';
import { IconButton as ButtonBase, IconButtonProps } from '@mui/material';
import { componentToken } from '../../style/utils';

type Props = IconButtonProps & {
  color?: 'error';
  width?: string;
  height?: string;
  variant?: 'outlined';
};

const IconButton = styled(ButtonBase)<Props>`
  border-radius: ${componentToken('iconButton.root.borderRadius')};
  padding: ${componentToken('iconButton.root.padding')};
  ${({ width }) => width && `width: ${width}`};
  height: ${({ height }) => height ?? 'fit-content'};
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  border: ${({ variant, theme }) =>
    variant === 'outlined'
      ? `1px solid ${theme.tokens.components.iconButton.root.border}`
      : 'none'};
`;

export default IconButton;
